import { render, staticRenderFns } from "./InterviewerrVideo.vue?vue&type=template&id=4ad30e3a&scoped=true&"
import script from "./InterviewerrVideo.vue?vue&type=script&lang=js&"
export * from "./InterviewerrVideo.vue?vue&type=script&lang=js&"
import style0 from "./InterviewerrVideo.vue?vue&type=style&index=0&id=4ad30e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad30e3a",
  null
  
)

export default component.exports